Customer.Ticket ||= {}

class Customer.Ticket.InteractionScheduleView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/interaction_schedule/interaction_schedule']
  className: 'interaction-schedule'

  events:
    'click .main': 'onClickMain'

  initialize: (@options = {}) ->
    @schedule = @options.schedule
    @canEdit = @options.canEdit

  render: ->
    @$el.html(@template(@schedule))
    if @schedule.get('status') == 'active'
      @$el.addClass('schedule-active')
      if @canEdit
        @$el.addClass('editable')
    else
      @$el.removeClass('schedule-active')
      @$el.removeClass('editable')
      @renderDetails()
    @

  renderDetails: ->
    if @schedule.get('status') == 'impacted'
      @detailsView = new Customer.Ticket.InteractionScheduleImpactedDetailsView(schedule: @schedule)
    else if @schedule.get('status') == 'suspended_by_operator'
      @detailsView = new Customer.Ticket.InteractionScheduleSuspendedByOperatorDetailsView(schedule: @schedule)
    else if @schedule.get('status') == 'suspended_by_new_interaction'
      @detailsView = new Customer.Ticket.InteractionScheduleSuspendedByNewInteractionDetailsView(schedule: @schedule)
    else
      console.warn("invalid schedule status: #{@schedule.get('status')}")

    @$el.append(@detailsView.render().$el)

  onClickMain: ->
    @openResponseSchedule() if @$el.hasClass('editable')

  openResponseSchedule: ->
    try
      @responseScheduleView = new Customer.Dashboard.ResponseScheduleView(parentView: @, responseSchedule: @schedule, edit: true)
      @$el.find('.response-schedule-container').html(@responseScheduleView.render().$el)
      @responseScheduleView.show()
    catch error
      swal(title: error.message, type: "warning")
    false

  saveResponseSchedule: (event, responseSchedule, callbacks) ->
    responseSchedule.save({}, {
      success: (model, response) =>
        if response.success
          callbacks.success()
          @schedule = responseSchedule
          setTimeout =>
            @render()
          , 1000
        else
          if response.error_code == 'stale_dialogue'
            @$el.find('#save').show()
            @$el.find('#saving').hide()
            swal({
                title: I18n.t('customer.dashboard.conversations.stale_dialogue.message_schedule')
                type: 'warning'
                showCancelButton: true
                confirmButtonClass: 'btn-success'
                confirmButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.refresh')
                cancelButtonText: I18n.t('customer.dashboard.conversations.stale_dialogue.dismiss')
                closeOnConfirm: true
              }, =>
                @$el.find('#response-schedule-edit').modal('hide')
                @trigger('updateSchedule:staleDialogue', response)
            )
          else
            @trigger('updateSchedule:error', response)
      error: (response) =>
        callbacks.error()
    })
